import React from "react";
import InternshipDirectoryListing from "./listing";

export default function AbsorbedInternshipDirectory(props) {
  return (
    <InternshipDirectoryListing
      {...props}
      fetchType="absorbed"
      title="Internship-to-Employment Placements"
      pageTitle="Internship-to-Employment Placements"
      dateLabel="Absorbed On"
      emptyMessage="No data found"
    />
  );
}
